var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.site==='gn')?_c('GNDownPC'):(_vm.site==='bn')?_c('BNDownPC'):(_vm.site==='mn')?_c('MNDownPC'):(_vm.site==='gf')?_c('GFDownPC'):(_vm.site==='gs')?_c('GRDownPC'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }